"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOADING = void 0;
const LOADING = exports.LOADING = 'loading';
